import { PaymentElement, useXpay } from '@xstak/xpay-element-stage';
import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../index.css';
import { printLogs } from '../utils/Utilities';
import { getFromLocalStorage, removeFromLocalStorage } from '../utils/localStorageUtils';
import { setCartCount } from '../store/reducers/auth';
import { appToken, cartsData } from '../utils/constants';

export const Payment = ({ slug, orderRef, instanceId, orderDate, merchantId, fromPaymentPage}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const options = {
    override: true,
    fields: {
      creditCard: {
        placeholder: "1234 1234 1234 1234",
        label: "Card Number",
      },
      exp: {
        placeholder: "MM/YY",
        label: "Expiry Date",
      },
    },
    style: {
      ".input": {
        "border": "2px solid #ccc",
        "border-radius": "8px",
        "padding": "10px",
        "margin": "10px 0",
        "font-size": "16px",
        "transition": "border 0.3s ease-in-out",
      },
      ".input:focus": {
        "border": "2px solid #007bff",
        "outline": "none",
      },
      ".label": {
        "font-size": "16px",
        "font-weight": "bold",
      },
      ".error": {
        "color": "red",
        "font-size": "14px",
      },
    },
  };

  const xpay = useXpay();
  const payNow = async () => {
    try {
      const token = getFromLocalStorage(appToken);

      setLoading(true);
      
      const payload = {
        slug,
        order_ref: orderRef,
      };
      
      if (instanceId) {
        payload.instance_id = instanceId;
      }

      const url = process.env.REACT_APP_API_URL + 'xpay-intent'
      const { clientSecret, encryptionKey, customer , merchantId } = await fetch(url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Outlet-Session-Token": token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => res);

      // removeFromLocalStorage(cartsData);
      // dispatch(setCartCount(0));

      const { message, responseStatus, success, data, error } = await xpay.confirmPayment("card", clientSecret, customer, encryptionKey);
      setLoading(false);
      // alert(message);
      printLogs('xPay confirm payment', { message, responseStatus, success, data })
      if (!error) {
        removeFromLocalStorage(cartsData);
        dispatch(setCartCount(0));
      }
      navigate(fromPaymentPage ? '/payment-receipt' : '/completeorder', { state: { order_id: orderRef, success: !error ? 1 : 0, created_at: orderDate, merchantId: merchantId } });

    } catch (e) {
      setLoading(false);
      // alert(e.message);

      printLogs('xPay confirm payment - error', { message: e.message, })
      navigate(fromPaymentPage ? '/payment-receipt' : '/completeorder', { state: { order_id: orderRef, success: 0, created_at: orderDate, merchantId: merchantId } });
    }
  }
  return (
    <div >
      <div className="step-header">
        <h3>Enter your card details</h3>
      </div>

      <PaymentElement options={options} onReady={(event) => {
        printLogs("ready event", event);
      }} />

      <button
        type="button"
        className="btn btn-block btn-dark mb-3"
        onClick={payNow}
        disabled={loading}
      >
        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <div className="spinner-border spinner-border-sm me-2" role="status">
              <span className="visually-hidden">Processing...</span>
            </div>
          </div>
        ) : (
          'Pay Now'
        )}
      </button>
    </div>
  )
}